<template>
  <section class="single-cat">
    <article>
      <div class="row clearfix">
        <h1>
          Ballet and Dance
          <!-- <a href="javascript:;" data-table="category-trends-table" class="infotoggle inline tooltipstered">Click for more info</a> -->
        </h1>
        <div class="sixcol">
          <p>Ballet and Dance experienced a moderate growth in revenue by 3.4% (from $64.0m in 2018 to $66.2m in 2019) and a slight growth in attendance by 0.3% (to 0.8m in 2019). The increase in the average ticket price by 1.5% (from $90.81 in 2018 to $92.17 in 2019) contributed to the growth in revenue. The revenue in Ballet and Dance was primarily driven by major performances such as <em>The Nutcracker, Alice's Adventures in Wonderland, Giselle</em> and <em>Sylvia</em>.</p>
          <p>Bans on mass gatherings, border closures and density limits introduced as part of COVID-19 restrictions resulted in a significant decline in revenue (by 88.6% to $7.5m) and a decline in attendance (by 82.9% to 0.1m) in 2020. The decline was also attributed to a decline in the average ticket price by 35.3% (to $59.64). The top events in this category in 2020 were <em>The Happy Prince, Volt, Shen Yun</em> and <em>The Nutcracker</em>.</p>
          <p>In 2019, 69.8% of revenue and 70.6% of attendance in Ballet and Dance was generated through performances by AMPAG / NPAP companies, such as The Australian Ballet, Sydney Dance Company, Bangarra Dance Theatre, Queensland Ballet and the West Australian Ballet. In 2020, 57.1% of revenue and 69.8% of attendance in Ballet and Dance was generated through performances by AMPAG / NPAP companies.</p>
        </div>
        <div class="sixcol last">
          <p>In 2019, NSW, Victoria and Queensland generated the most revenue and attendance in this category, accounting for a combined 85.7% of overall revenue and 78.7% of attendance. In 2020, NSW, WA and QLD generated the most revenue and attendance, accounting for a combined 88.0% of overall revenue and 88.1% of attendance.</p>
          <p>In 2019, NT experienced the highest y-o-y growth in revenue (38.5%), despite a moderate decline in attendance (3.1%), driven by major performances such as <em>Bennelong, Celtic Illusion</em> and <em>Bangarra: 30 years of sixty five thousand</em>.</p>
          <p>QLD experienced the second highest y-o-y growth in revenue (36.3%) and attendance (28.5%), driven by major performances including <em>Bolshoi Ballet: Spartacus</em>, <em>Romeo & Juliet</em> and <em>Alice's Adventures in Wonderland</em>.</p>
          <p>In 2020, all states experienced a significant decline in revenue and attendance in this category, due to COVID-19 restrictions and limited touring activity of AMPAG / NPAP companies.</p>
        </div>
      </div>
    </article>

    <figure class="chart">
      <div class="row clearfix">
        <highcharts class="graphcontainer" :options="totalRevenueAttendance"></highcharts>
      </div>
    </figure>

    <figure v-if="false" id="category-trends-table" class="data">
      <div class="row clearfix">
        <a href="#" data-table="category-trends-table" class="closetable"
           title="Total revenue and attendances by category (2018)">Close Table</a>
        <h3>Total Revenue and Attendance by Category (2018)</h3>
        <table cellspacing="0" cellpadding="0">
          <thead>
          <tr>
            <th valign="top" width="20%">Category</th>
            <th valign="top">Revenue</th>
            <th valign="top" width="15%">% change in revenue (from 2017)</th>
            <th valign="top">Share of industry</th>
            <th valign="top">Attendance</th>
            <th valign="top" width="17%">% change in attendance (from 2017)</th>
            <th valign="top">Share of industry</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td valign="bottom">Ballet and Dance</td>
            <td valign="middle" class="number">$63,988,882</td>
            <td valign="middle" class="number">2.6%</td>
            <td valign="middle" class="number">3.0%</td>
            <td valign="middle" class="number">800,781</td>
            <td valign="middle" class="number">-1.2%</td>
            <td valign="middle" class="number">3.0%</td>
          </tr>
          <tr>
            <td valign="bottom">Children's/Family</td>
            <td valign="middle" class="number">$59,777,596</td>
            <td valign="middle" class="number">16.5%</td>
            <td valign="middle" class="number">2.8%</td>
            <td valign="middle" class="number">1,650,955</td>
            <td valign="middle" class="number">26.4%</td>
            <td valign="middle" class="number">6.3%</td>
          </tr>
          <tr>
            <td valign="bottom">Classical Music</td>
            <td valign="middle" class="number">$79,456,707</td>
            <td valign="middle" class="number">2.0%</td>
            <td valign="middle" class="number">3.7%</td>
            <td valign="middle" class="number">1,261,565</td>
            <td valign="middle" class="number">-4.3%</td>
            <td valign="middle" class="number">4.8%</td>
          </tr>
          <tr>
            <td valign="bottom">Festivals (Multi-Category)</td>
            <td valign="middle" class="number">$68,972,653</td>
            <td valign="middle" class="number">26.2%</td>
            <td valign="middle" class="number">3.2%</td>
            <td valign="middle" class="number">2,577,932</td>
            <td valign="middle" class="number">38.1%</td>
            <td valign="middle" class="number">9.8%</td>
          </tr>
          <tr>
            <td valign="bottom">Festivals (Contemporary Music)</td>
            <td valign="middle" class="number">$102,015,922</td>
            <td valign="middle" class="number">1.3%</td>
            <td valign="middle" class="number">4.7%</td>
            <td valign="middle" class="number">975,233</td>
            <td valign="middle" class="number">14.4%</td>
            <td valign="middle" class="number">3.7%</td>
          </tr>
          <tr>
            <td valign="bottom">Musical Theatre</td>
            <td valign="middle" class="number">$400,199,798</td>
            <td valign="middle" class="number">-4.0%</td>
            <td valign="middle" class="number">18.5</td>
            <td valign="middle" class="number">3,917,532</td>
            <td valign="middle" class="number">-3.1%</td>
            <td valign="middle" class="number">14.9%</td>
          </tr>
          <tr>
            <td valign="bottom">Contemporary Music</td>
            <td valign="middle" class="number">$1,092,275,549</td>
            <td valign="middle" class="number">32.2%</td>
            <td valign="middle" class="number">50.5%</td>
            <td valign="middle" class="number">10,088,329</td>
            <td valign="middle" class="number">19.2%</td>
            <td valign="middle" class="number">38.4%</td>
          </tr>
          <tr>
            <td valign="bottom">Opera</td>
            <td valign="middle" class="number">$46,965,221</td>
            <td valign="middle" class="number">29.2%</td>
            <td valign="middle" class="number">2.2%</td>
            <td valign="middle" class="number">487,195</td>
            <td valign="middle" class="number">31.9%</td>
            <td valign="middle" class="number">1.9%</td>
          </tr>
          <tr>
            <td valign="bottom">Special Events</td>
            <td valign="middle" class="number">$22,115,160</td>
            <td valign="middle" class="number">337.9%</td>
            <td valign="middle" class="number">1.0%</td>
            <td valign="middle" class="number">170,359</td>
            <td valign="middle" class="number">24.5%</td>
            <td valign="middle" class="number">0.6%</td>
          </tr>
          <tr>
            <td valign="bottom">Theatre</td>
            <td valign="middle" class="number">$78,505,052</td>
            <td valign="middle" class="number">22.2%</td>
            <td valign="middle" class="number">3.6%</td>
            <td valign="middle" class="number">1,430,263</td>
            <td valign="middle" class="number">-1.9%</td>
            <td valign="middle" class="number">5.4%</td>
          </tr>
          <tr>
            <td valign="bottom">Circus and Physical Theatre</td>
            <td valign="middle" class="number">$23,410,423</td>
            <td valign="middle" class="number">-79.9%</td>
            <td valign="middle" class="number">1.1%</td>
            <td valign="middle" class="number">450,446</td>
            <td valign="middle" class="number">-61.3%</td>
            <td valign="middle" class="number">1.7%</td>
          </tr>
          <tr>
            <td valign="bottom">Comedy</td>
            <td valign="middle" class="number">$124,742,437</td>
            <td valign="middle" class="number">72.5%</td>
            <td valign="middle" class="number">5.8%</td>
            <td valign="middle" class="number">2,458,198</td>
            <td valign="middle" class="number">98.5%</td>
            <td valign="middle" class="number">9.4%</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td valign="bottom">Total</td>
            <td valign="middle" class="number">$2,162,425,399</td>
            <td valign="middle" class="number">14.8%</td>
            <td valign="middle" class="number">100%</td>
            <td valign="middle" class="number">26,268,788</td>
            <td valign="middle" class="number">14.1%</td>
            <td valign="middle" class="number">100%</td>
          </tr>
          </tfoot>
        </table>
      </div>
    </figure>

    <figure id="ballet-dance-states" class="chart">
      <div class="row clearfix">
        <h1>State/Territory Breakdown</h1>

        <ul class="switches">
          <li><a href="javascript:;" :class="{active: activeYear==2019}"
            @click="activeYear=2019">2019</a></li>
          <li><a href="javascript:;" :class="{active: activeYear==2020}"
            @click="activeYear=2020">2020</a></li>
        </ul>

        <div class="chart-wrapper">
          <highcharts class="graphcontainer" :options="activeStateBreakdown"></highcharts>
          <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
        </div>
      </div>
    </figure>

    <div class="fullbg">
      <p class="caption">Photo: <em>Dance Locale - Coast (Maroubra)</em>, Sydney Dance Company, Photo Credit: Daniel Boud</p>
    </div>
  </section>
</template>

<script>
/*eslint-disable */

export default {
  data () {
    return {
      totalRevenueAttendance: {
        chart: {
          backgroundColor: null,
        },
        title: {
          text: ''
        },
        xAxis: [{
          categories: ["2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
          labels: {
            style: {
              color: '#fff'
            }
          }
        }],
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value > 999) {
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            formatter: function() {
              if (this.value < 1) {
                return (this.value * 1000) + 'k'
              } else {
                return this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter: function() {
            let revy, tooltipstring;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            } else {
              revy = '$' + rev.y + 'm'
            }
            if (att.y < 1) {
              atty = (att.y * 1000).toFixed(0) + 'k'
            } else {
              atty = att.y + 'm'
            }

            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy + '<br />'
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            return tooltipstring
          }
        },
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 120,
          verticalAlign: 'top',
          y: 100,
          floating: true,
          backgroundColor: '#fff'
        },
        series: [{
          name: 'Revenue',
          type: 'column',
          data: [30.664, 44.563, 52.524, 77.287, 47.052, 58.571, 57.509, 59.164, 57.866, 62.833, 52.772, 63.522, 60.08, 62.339, 63.989, 66.159, 7.535],
          color: '#3a89eb'
        }, {
          name: 'Attendance',
          type: 'column',
          yAxis: 1,
          data: [0.683, 0.931, 1.114, 1.457, 0.935, 1.051, 1.023, 0.948, 0.92, 0.976, 0.768, 0.859, 0.815, 0.81, 0.801, 0.803, 0.137],
          color: '#d14967'
        }]
      },
      activeYear: 2019,
      stateBreakdowns: [
        {
          year: 2019,
          revenue: [
            ["NSW", 34.4],
            ["VIC", 29.9],
            ["QLD", 21.4],
            ["WA", 7.8],
            ["SA", 3.4],
            ["ACT", 1.8],
            ["TAS", 0.7],
            ["NT", 0.6]
          ],
          attendance: [
            ["NSW", 28.4],
            ["VIC", 25.4],
            ["QLD", 24.9],
            ["WA", 12.3],
            ["SA", 3.9],
            ["ACT", 2.8],
            ["TAS", 1.1],
            ["NT", 1.1]
          ]
        },
        {
          year: 2020,
          revenue: [
            ["NSW", 36.6],
            ["VIC", 6.8],
            ["QLD", 17.5],
            ["WA", 33.8],
            ["SA", 2.6],
            ["ACT", 2.2],
            ["TAS", 0.0],
            ["NT", 0.5]
          ],
          attendance: [
            ["NSW", 25.2],
            ["VIC", 4.4],
            ["QLD", 21.1],
            ["WA", 41.8],
            ["SA", 3.6],
            ["ACT", 3.1],
            ["TAS", 0.0],
            ["NT", 0.8]
          ]
        }
      ],
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    activeStateBreakdown () {
      const self = this

      for (let i = 0; i < self.stateBreakdowns.length; i++) {
        const stateBreakdown = self.stateBreakdowns[i]
        if (stateBreakdown.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick: e => {
                      e.preventDefault();
                      return false;
                    }
                  }
                }
              }
            },
            legend: {
              align: 'right',
              layout: 'vertical',
              verticalAlign: 'middle',
              itemMarginBottom: 10,
              itemStyle: {
                color: '#fff'
              },
              itemHoverStyle: {
                color: '#fff'
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 1
            },
            series: [{
              name: 'Revenue Share',
              data: stateBreakdown.revenue,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: true,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              }
            }, {
              name: 'Attendance Share',
              data: stateBreakdown.attendance,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none',
                },
                formatter: function() {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -32
              }
            }],
            colors: [
              '#f66262',
              '#f2914a',
              '#5fa62b',
              '#6598d3',
              '#594ebb',
              '#bc56c3',
              '#c3567f',
              '#edc055'
            ]
          }
        }
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.single-cat {
  background-image: url(../../../assets/img/2019/Dance-Locale---Coast-%28Maroubra%29%2C-Sydney-Dance-Company%2C-Daniel-Boud_SFW2.jpg);
}
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
